import { Icon } from 'assets/index'
import { useContext, useState } from 'react'
import { UserContext } from 'context/userContext'
import { useFetch } from 'hooks'
import { Content, Button, InputError } from './style'

interface IProps {
  onCancel?: () => void
  id?: string
  backModal?: boolean
}
const DeleteProposta = (props: IProps) => {
  const { onCancel, id, backModal } = props
  const { selectedId } = useContext(UserContext)
  const [erro, setErro] = useState<boolean | string>(false)
  const api = useFetch(`/gestor/token/${selectedId.current}`)

  const backPage = () => {
    const button = document.getElementById('button-back-modal')
    button?.click()
  }

  const handleDelete = () => {
    setErro(false)
    console.log('Aqui', id, id?.slice(0, 3))
    if (id?.slice(0, 3) === 'ret') {
      console.log('RETROATIVOOOOOO')
      return api
        .fetch('delete', null, `/gestor/retroactive/${id}`)
        .then((r) => {
          console.log(r)
          if (r.fail) {
            // return setErro(r.errors.message)
            return setErro('Nao foi possível excluir a proposta')
          }
          backModal && backPage()
          onCancel && onCancel()
        })
        .catch((err) => {
          console.log(err)
          return setErro('Erro')
        })
    }
    api
      .fetch('delete')
      .then((r) => {
        console.log('deletou?', r)
        if (r.fail) {
          // return setErro(r.errors.message)
          return setErro('Nao foi possível excluir a proposta')
        }
        backModal && backPage()
        onCancel && onCancel()
      })
      .catch((err) => {
        console.log(err)
        return setErro('Erro')
      })
  }

  return (
    <Content>
      <div className="row">
        <img
          className="red-icon"
          src={Icon('alert_triangle.svg')}
          alt="alert"
        />
        <p className="big-red-title">Excluir proposta</p>
      </div>
      <p className="black-title">Tem certeza que quer excluir esta proposta?</p>
      <p className="black-content">
        Você está prestes a realizar uma exclusão definitiva no sistema
        <br />
        que não pode ser desfeita, confirma que deseja excluir?
      </p>
      <InputError>{erro}</InputError>
      <div className="row">
        <Button onClick={onCancel}>
          <img src={Icon('x.svg')} alt="close modal" className="icon" />
          <p>Cancelar</p>
        </Button>
        <div style={{ marginLeft: 40 }}>
          <Button red onClick={handleDelete}>
            <img src={Icon('trash.svg')} alt="close modal" className="icon" />
            <p>Excluir definifivamente</p>
          </Button>
        </div>
      </div>
    </Content>
  )
}

export default DeleteProposta
